import { CodeBook } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils";

import { ProgramCodeBookExport } from "../../models/CodeBook/ProgramCodeBookExport";
import { ProgramCodeBook, EditProgramCodeBookRequest } from "../../models/Program";
import { normalizeProgram, toProgramApiRequest } from "./programMappers";

const programUrlPrefix: string = "programs";

export const getPrograms = async () => {
  let result = await api.get(
    `${programUrlPrefix}/detail`
  ) as ProgramCodeBook[];
  setDatesPrograms(result);
  return result;
}

export const getProgramByName = async (name: CodeBook) => {
  let result = await api.get(
    `${programUrlPrefix}/by-name`,
    name
  ) as ProgramCodeBook;
  normalizeProgram(result);
  return result
}

export const createProgram = async (request: EditProgramCodeBookRequest) => {
  const payload = toProgramApiRequest(request);
  return api.post(
    `${programUrlPrefix}`,
    payload
  ) as Promise<number>
}

export const editProgram = async (id: number, request: EditProgramCodeBookRequest) => {
  const payload = toProgramApiRequest(request);
  return api.put(
    `${programUrlPrefix}/${id}`,
    payload
  ) as Promise<void>
}

export const deleteProgram = async (id: number) => {
  return api.delete(
    `${programUrlPrefix}/${id}`
  ) as Promise<void>
}

export const exportPrograms = async (request: ProgramCodeBookExport) => {
  var result = await (api.download(
    `${programUrlPrefix}/export`,
    "get",
    request
  ) as Promise<unknown>);
  return result
}

export const searchProgramNames = async(search: string) => {
  const request = { search };
  let url = `${programUrlPrefix}/search?search=${search}`;  
  return api.get(url, request) as Promise<CodeBook[]>;
}

export const searchProgramNamesV2 = async(search: string) => {
  const request = { search };
  let url = `${programUrlPrefix}/searchV2?search=${search}`;  
  return api.get(url, request) as Promise<CodeBook[]>;
}

const setDatesPrograms = (items: ProgramCodeBook[]) => {
  for (let item of items) {
    normalizeProgram(item);
  }
}